import { QueryKey } from "@tanstack/react-query";

export const INVENTORY_KEYS = {
  INVENTORIES: "clientManagement/inventories",
  GET_INVENTORIES: (params: unknown): QueryKey => [
    INVENTORY_KEYS.INVENTORIES,
    params,
  ],
  GET_INVENTORIES_INFINITE: (params: unknown): QueryKey => [
    `${INVENTORY_KEYS.INVENTORIES}/infinite`,
    params,
  ],
  GET_INVENTORY: (id: string): QueryKey => [INVENTORY_KEYS.INVENTORIES, id],
  GET_INVENTORY_METRICS: (): QueryKey => [
    INVENTORY_KEYS.INVENTORIES,
    "metrics",
  ],
  GET_INVENTORIES_BY_IDS: (ids: string[]) => [
    INVENTORY_KEYS.INVENTORIES,
    "by-ids",
    ids.sort().join(","),
  ],

  // Client inventory specific keys
  CLIENT_INVENTORY: "client/inventory",
  GET_CLIENT_INVENTORY: (): QueryKey => [INVENTORY_KEYS.CLIENT_INVENTORY],
  GET_CLIENT_INVENTORY_ITEM: (id: string): QueryKey => [
    INVENTORY_KEYS.CLIENT_INVENTORY,
    id,
  ],
  SEARCH_CLIENT_INVENTORY: (keyword: string): QueryKey => [
    INVENTORY_KEYS.CLIENT_INVENTORY,
    "search",
    keyword,
  ],
  FILTER_CLIENT_INVENTORY: (status: string): QueryKey => [
    INVENTORY_KEYS.CLIENT_INVENTORY,
    "filter",
    status,
  ],
  GET_INVENTORIES_TICKET: (params: unknown): QueryKey => [
    `${INVENTORY_KEYS.INVENTORIES}/ticket`,
    params,
  ],
};
